import React, { useState, useEffect, useRef } from 'react'
import Print from '../../../Common_Files/Print';
import { Host } from '../../../App';
import Axios from 'axios'
import InventoryReportTable from './InventoryReportTable';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { format } from 'date-fns';
import './Temporary_Inventory.css'

function His_Inventory({ AllColumns, Areas }) {
  const [partDataset, setpartDataset] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [AllpartDataset, setAllpartDataset] = useState([]);

  const [PartNo, setPartno] = useState({});
  const [PartDesc, setPartDesc] = useState({});
  const [InternalPart, setInternalPart] = useState({});
  const [Customers, setCustomers] = useState({});
  const [Category, setCategory] = useState({});
  const [Type, setType] = useState({});
  const [Area, setArea] = useState({});
  const [flex_inv, setflex_inv] = useState(false);
  const [Edit, SetEdit] = useState(false);
  const [rigid_inv, setrigid_inv] = useState(false);
  const [del, setdel] = useState(0);
  const tableRef = useRef(null);
  var token = (window.localStorage.getItem("acessToken"));
  var user = (window.localStorage.getItem("Name"));
  const [inputValues, setInputValues] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);



  var [Date1, setDate1] = useState(new Date());
  const formattedDate = new Date(Date1).toLocaleDateString();
  var [Postartdate, setPoStartdate] = useState('');
  var [Poenddate, setPoEnddate] = useState(Date1.toISOString().slice(0, 10));
  const [printTrigger, setPrintTrigger] = useState(false);
  const handlePrint = () => {
    const tableHTML = tableRef.current?.innerHTML;
    setPrintTrigger({ html: tableHTML });
  };
  const queryParams = {
    token: token,
  };

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/Inventory/partdataset`, { params: partfilters }).then((data) => {
      setAllpartDataset(data.data)
      console.log("Entire Part Dataset for datalist: ", data.data);
    });
  }, [])


  useEffect(() => {
    Axios.get(`https://` + Host + `/latestdate/Inventory`, { params: queryParams })
      .then((res) => {
        const iso = res.data[0]?.latest;       // "2025-07-27T06:00:00.000Z"
        if (iso) {
          setPoStartdate(iso.slice(0, 10));    // "2025-07-27"
        }
      })
      .catch((error) => {
        console.error("Error fetching production schedule:", error);
      });
  }, []);
  const [data, setData] = useState([
    {
      Date: '',
      PartNo: '',
      Part_internalNo: '',
      Part_description: '',
      Customer: '',
      Type: '',
      Area: '',
      QTY: '',
      User: user.replace(/[{"}]/g, "")
    }
  ]);
  const addNewRow = (index) => {
    const newRow = {
      Date: '',
      PartNo: '',
      Part_internalNo: '',
      Part_description: '',
      Customer: '',
      Type: '',
      Area: '',
      QTY: '',
    };

    const newData = [...data];
    newData.splice(index + 1, 0, newRow);
    setData(newData);
  };

  const partfilters = {
    PartNo: PartNo,
    PartDesc: PartDesc,
    Customers: Customers,
    Start_date: Postartdate,
    End_date: Poenddate,
    token: token,
    InternalPart: InternalPart,
    Type: Type,
    Area: Area
  }
  const Add_New = () => {
    const invalidEntry = data.find(part => {
      return !part.Date || !part.PartNo || !part.Area || !part.QTY || Number(part.QTY) <= 0;
    });

    if (invalidEntry) {
      let missingFields = [];
      if (!invalidEntry.Date) missingFields.push("Date");
      if (!invalidEntry.PartNo) missingFields.push("Part No");
      if (!invalidEntry.Area) missingFields.push("Area");
      if (!invalidEntry.QTY || Number(invalidEntry.QTY) <= 0) missingFields.push("Valid QTY");

      alert(`Please enter the following fields: ${missingFields.join(", ")}`);
      return; // Stop submission if validation fails
    }

    const changedData_ = data
      .filter(part => Number(part.QTY) > 0)
      .map(part => ({
        ...part,
        user
      }));
    let tosend = changedData_[0].Area.replace(/\s+/g, '');
    Axios.post(`https://` + Host + `/Part_Inventory/${tosend}/Add`, {
      changedData: JSON.stringify(changedData_),
      token
    })
      .then(res => {
        if (res.status === 200) {
          alert(res.data.message);

          // localStorage.removeItem('FlexunsavedPartsData'); // Clear local storage after successful update
          window.location.reload();
          setdel(del + 1);
        }
      })
      .catch(err => console.error(err));
  };

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/get/History/Inventory`, { params: partfilters }).then((data) => {
      setpartDataset(data.data)
      console.log("Part Inventory Dataset: ", data.data);
    });
  }, [PartNo, PartDesc, Customers, Postartdate, Poenddate, Category, del, InternalPart, Type, Area])
  const getFormattedDateTime = (date) => {
    return format(date, 'yyyy-MM-dd HH:mm:ss');
  };
  const [changedRows, setChangedRows] = useState(new Set());

  const handleUpdate = (e, index, key) => {
    const { value } = e.target;
    const newData = [...partDataset];
    newData[index][key] = value;

    // Check if the key is Internal_Part_No, then call submitValue
    updateData(index, key, value);
  };

  // method to retrieve data combinely
  const updateData = (index, key, value) => {
    setpartDataset(prevData => {
      const newData = [...prevData];
      newData[index][key] = value;

      const isValid = (row) => {
        // Helper function to check if a date is valid
        const isValidDate = (date) => {
          return date && date !== '0000-00-00' && !isNaN(new Date(date).getTime());
        };

        return (
          row.Produced &&
          isValidDate(row.Date)
        );
      };

      if (isValid(newData[index])) {

      }
      setChangedRows(prevRows => {
        const newSet = new Set(prevRows);
        newSet.add(index);
        return newSet;
      });

      return newData;
    });
  };
  const Update = () => {

    let changedData = [...changedRows].map(index => {
      return partDataset[index];
    });

    if (changedData.length > 0) {

      setIsLoading(true);
      Axios.post(`https://` + Host + `/Inventory/Update`, { changedData: JSON.stringify(changedData), token: token, user: user, date: (getFormattedDateTime(Date1)) })
        .then((response) => {
          if (response.status === 200) {
            toast.success(response.data.message, {
              autoClose: 1000,
              position: toast.POSITION.TOP_RIGHT,
              style: { fontSize: '24px', borderRadius: '10px', color: 'red' },
            });
            setIsLoading(false);
            // setChangedRows(new Set());
            SetEdit(false);
          }
        })
        .catch(function (error) {
          window.alert(error);
          setIsLoading(false);
        })
    } else {
      toast.error("No Valid Data !", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
        style: { fontSize: '24px', borderRadius: '10px' },
      });

    }

  };
  // To delete the entire row

  const handleCheckboxChange = (row) => {
    const rowDate = (row.Date || '').slice(0, 10);

    const exists = selectedRows.find(r =>
      r.Date === rowDate &&
      r.Internal_Part_No === row.Internal_Part_No &&
      r.Area === row.Area
    );

    if (exists) {
      // unselect
      setSelectedRows(selectedRows.filter(r =>
        !(
          r.Date === rowDate &&
          r.Internal_Part_No === row.Internal_Part_No &&
          r.Area === row.Area
        )
      ));
    } else {
      // select
      setSelectedRows([
        ...selectedRows,
        {
          Date: rowDate,
          Internal_Part_No: row.Internal_Part_No,
          Area: row.Area
        }
      ]);
    }
  };



  const Delete = () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row to delete.");
      return;
    }

    const confirmDelete = window.confirm(
      `Do you want to delete ${selectedRows.length} selected entries?`
    );

    if (!confirmDelete) return;

    setIsLoading(true);

    Axios.delete(`https://` + Host + `/Inventory/delete`, {
      data: {
        selectedRows,
        token
      }
    })
      .then((response) => {
        if (response.status === 200) {
          alert(response.data.message);
          setSelectedRows([]);
          setdel(del + 1);
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };



  useEffect(() => {
    let changedData = [...changedRows].map(index => {
      return partDataset[index];
    });
    if (changedData.length > 0) {
      Update();
    }
  }, [changedRows])

  // put this inside your component
  const displayedDate = React.useMemo(() => {
    if (!partDataset || partDataset.length === 0) return '';
    // If all rows share the same date, show that; otherwise show a range
    const dates = [...new Set(partDataset.map(r => (r.Date || '').slice(0, 10)))].sort();
    return dates.length === 1 ? dates[0] : `${dates[0]} — ${dates[dates.length - 1]}`;
  }, [partDataset]);

  return (
    <div>
      <div class="row">
        {!rigid_inv && !flex_inv && (
          <>
            <div className="col">
              <input
                type="text"
                className="form-control form-rounded"
                placeholder="Part No"
                onChange={(e) => setPartno(e.target.value)}
                list="PartNo"
              />
              <datalist id="PartNo">
                <option></option>
                {partDataset.map((x, i) => (
                  <option key={i}>{x.Part_No}</option>
                ))}
              </datalist>
            </div>

            <div className="col">
              <div className="row">
                <input
                  type="text"
                  className="form-control form-rounded"
                  placeholder="Part Description"
                  onChange={(e) => setPartDesc(e.target.value)}
                  list="PartDescription"
                />
                <datalist id="PartDescription">
                  <option></option>
                  {partDataset.map((x, i) => (
                    <option key={i}>{x.Part_Description}</option>
                  ))}
                </datalist>
              </div>

              <div className="row">
                <input
                  type="text"
                  className="form-control form-rounded"
                  placeholder="Internal Part No"
                  onChange={(e) => setInternalPart(e.target.value)}
                  list="InternalPart"
                />
                <datalist id="InternalPart">
                  <option></option>
                  {[...new Set(partDataset.map((x) => x.Internal_Part_No))].map((Internal_Part_No, index) => (<option key={index}>{Internal_Part_No}</option>))}
                </datalist>
              </div>
            </div>

            <div className="col">
              <input
                type="text"
                className="form-control form-rounded"
                placeholder="Customer"
                onChange={(e) => setCustomers(e.target.value)}
                list="Customer"
              />
              <datalist id="Customer">
                <option></option>
                {[...new Set(partDataset.map((x) => x.Customer))].map((Customer, index) => (
                  <option key={index}>{Customer}</option>
                ))}
              </datalist>
            </div>

            <div className="col">
              <div class="row">

                {/* Grab the Itemicular dates */}
                <input type='date' class="form-control form-rounded" id='supplychain-button' defaultValue={Postartdate} onChange={(e) => {
                  setPoStartdate(e.target.value)
                }} />
                <div class="row">
                  <input type='date' class="form-control form-rounded" id='supplychain-button' defaultValue={Date1.toISOString().slice(0, 10)} onChange={(e) => { setPoEnddate(e.target.value) }} />
                </div>
              </div>
            </div>

            <div className="col">
              <div className="row">
                <input
                  type="text"
                  className="form-control form-rounded"
                  placeholder="Type"
                  onChange={(e) => setType(e.target.value)}
                  list="Type"
                />
                <datalist id="Type">
                  <option></option>
                  {[...new Set(partDataset.map((x) => x.Type))].map((type, index) => (
                    <option key={index}>{type}</option>
                  ))}
                </datalist>
              </div>
              <div className="row">
                <div className="col"><button className='btn btn-info' onClick={handlePrint}>Print</button></div>
              </div>
            </div>
            <div className="col">
              <div className="row">

                <input
                  type="text"
                  className="form-control form-rounded"
                  placeholder="Area"
                  onChange={(e) => setArea(e.target.value)}
                  list="Area"
                />
                <datalist id="Area">
                  <option value="Flex" />
                  <option value="Rigid" />
                  <option value="Slap Foam" />
                </datalist>
              </div>
              <div className="row">

                <div className="col"><button className='btn btn-info' onClick={() => SetEdit(!Edit)}>Edit</button></div>
              </div>
            </div>
          </>
        )}


      </div>

      {Edit ? (
        <div className="add_section" id="Part_dataset_add">
          {data.map((line, index) => {
            const handleInternalPartChange = (e) => {
              const value = e.target.value;
              const matched = AllpartDataset.find(p => p.Part_internalNo === value);

              const newData = [...data];
              newData[index].Part_internalNo = value;

              if (matched) {
                newData[index].PartNo = matched.Part_No || '';
                newData[index].Customer = matched.Customer || '';
                newData[index].Part_description = matched.Part_Description || '';
                newData[index].Type = matched.Type || '';
              }

              setData(newData);
            };

            return (
              <div key={index} className="row mb-2">
                <div className="col">
                  <input
                    type="date"
                    className="form-control form-rounded"
                    value={line.Date}
                    onChange={e => {
                      const newData = [...data];
                      newData[index].Date = e.target.value;
                      setData(newData);
                    }}
                  />
                </div>

                <div className="col-2">
                  <input
                    type="text"
                    className="form-control form-rounded"
                    value={line.Part_internalNo || ''}
                    onChange={handleInternalPartChange}
                    list="InternalPartNo"
                    placeholder="Internal Part No"
                  />
                  <datalist id="InternalPartNo">
                    <option></option>
                    {AllpartDataset.map((x, idx) => (
                      <option key={x.Part_internalNo + idx}>{x.Part_internalNo}</option>
                    ))}
                  </datalist>
                </div>

                <div className="col">
                  <input
                    type="text"
                    className="form-control form-rounded"
                    value={line.PartNo || ''}
                    readOnly
                    placeholder="Part No"
                  />
                </div>

                <div className="col">
                  <input
                    type="text"
                    className="form-control form-rounded"
                    value={line.Part_description || ''}
                    readOnly
                    placeholder="Part Description"
                  />
                </div>

                <div className="col">
                  <input
                    type="text"
                    className="form-control form-rounded"
                    value={line.Customer || ''}
                    readOnly
                    placeholder="Customer"
                  />
                </div>

                <div className="col">
                  <input
                    type="text"
                    className="form-control form-rounded"
                    value={line.Type || ''}
                    readOnly
                    placeholder="Type"
                  />
                </div>

                <div className="col">
                  <select
                    className="form-control form-rounded"
                    value={line.Area || ''}
                    onChange={e => {
                      const newData = [...data];
                      newData[index].Area = e.target.value;
                      setData(newData);
                    }}
                  >
                    <option value="">Select Area</option>
                    <option value="Flex">Flex</option>
                    <option value="Rigid">Rigid</option>
                    <option value="Slap Foam">Slap Foam</option>
                  </select>

                </div>

                <div className="col-1">
                  <input
                    type="number"
                    className="form-control form-rounded"
                    value={line.QTY || ''}
                    onChange={e => {
                      const newData = [...data];
                      newData[index].QTY = e.target.value;
                      setData(newData);
                    }}
                    placeholder="Qty"
                  />
                </div>

                <div className="col-auto">
                  <button
                    onClick={() => addNewRow(index)}
                    className="btn btn-outline-primary"
                  >
                    +
                  </button>
                </div>
              </div>
            );
          })}

          <button className="btn btn-primary" onClick={Add_New}>Submit</button>
        </div>
      ) : null}
      <div ref={tableRef}>
        <div className="mb-8">
          Date: {displayedDate || '—'}
        </div>
        <div className="inventory_table">
          <table class="table table-bordered table-striped" id="alldata_openorder">


            <thead>
              <tr>
                {Edit ? <th>SELECT</th> : null}
                <th>PART NO</th>
                <th>DATE</th>
                {AllColumns ? <th>INTERNAL PART NO</th> : null}
                <th>PART DESCRIPTION</th>
                {AllColumns ? <th>CUSTOMER</th> : null}
                {AllColumns ? <th>TYPE</th> : null}
                <th>AREA</th>
                <th>INVENTORY QTY</th>
                {Edit ? <th>DELETE</th> : null}

              </tr>
            </thead>

            <tbody>
              {partDataset.map((val, index) => (
                <tr key={index}>
                  {Edit ? <td><input
                    type="checkbox"
                    class="form-check-input"
                    checked={selectedRows.some(r =>
                      r.Date === (val.Date || '').slice(0, 10) &&
                      r.Internal_Part_No === val.Internal_Part_No &&
                      r.Area === val.Area
                    )}


                    onChange={() => handleCheckboxChange(val)}

                  /></td> : null}
                  <td>{(val.Date || '').slice(0, 10)}</td>

                  <td>{val.Part_No}</td>
                  {AllColumns ? <td>{val.Internal_Part_No}</td> : null}
                  <td>{val.Part_Description}</td>
                  {AllColumns ? <td>{val.Customer}</td> : null}
                  {AllColumns ? <td>{val.Type}</td> : null}
                  <td>{val.Area || ''}</td>
                  <td>
                    {Edit ? (
                      <input
                        type="number"
                        className="form-control form-rounded"
                        value={inputValues[index] ?? val.Inventory_Parts ?? ''}
                        onChange={(e) =>
                          setInputValues(prev => ({ ...prev, [index]: e.target.value }))
                        }
                        onBlur={(e) => {
                          handleUpdate(e, index, 'Inventory_Parts');
                          // Optional: clear temp after save
                          setInputValues(prev => {
                            const newVals = { ...prev };
                            delete newVals[index];
                            return newVals;
                          });
                        }}
                      />
                    ) : (
                      val.Inventory_Parts === 0 || val.Inventory_Parts === null ? '' : val.Inventory_Parts
                    )}
                  </td>

                  {Edit ? (
                    <td>
                      <button
                        className="btn btn-danger"
                        onClick={() => {
                          if (!selectedRows) {
                            alert("Please select a row to delete.");
                            return;
                          }
                          const confirmDelete = window.confirm("Do you want to delete this entry?");

                          if (confirmDelete) {
                            Delete(); // replace this with your actual delete function
                          }
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  ) : null}

                </tr>
              ))}
            </tbody>

          </table></div>
      </div>
      {printTrigger && (
        <Print
          tableHTML={printTrigger.html}
          title={Areas}
          user="Vikas"
          onComplete={() => setPrintTrigger(false)}
        />
      )}
      {isLoading ?
        <div className='overlay'>
          <div class="text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div> : null}

    </div>
  )
}

export default His_Inventory